<template>
  <div>
    <a-collapse accordion v-model="activeKey">
      <a-collapse-panel header="Requisiciones" key="1">
        <g-master name="requisiciones"
                  :endpoint="requisiciones.endpoint"
                  :tableSetup="requisiciones.tableSetup"
                  :actions="requisiciones.actions"
                  @action="masterAction"
                  ref="masterComponent">
          <template slot="expandedRowRender" slot-scope="{text}">
            <template v-for="ve in requisiciones.valoresExpandidos">
              {{ve.label}}: <span style="font-weight: bold;">{{text[ve.column]}}</span><br/>
            </template>
          </template>
          <span slot="estadoRenderer" slot-scope="{text}">
                        <a-tag
                          :color="text==='RECHAZADA' ? 'red' : (text === 'CERRADA' ? 'green' : 'blue')">{{text}}</a-tag>
                    </span>
        </g-master>
      </a-collapse-panel>
      <a-collapse-panel header="Detalles de Requisición" key="2" :disabled="!requisicionSeleccionada.req_id"
                        forceRender>
        <gestionar-requisicion :requisicion.sync="requisicionSeleccionada"
                               @reqUpdated="refreshTable"></gestionar-requisicion>
      </a-collapse-panel>
      <a-collapse-panel header="Detalles de Candidatos" key="3" :disabled="!requisicionSeleccionada.req_id">
        <detalle-de-candidatos-requisicion
          :requisicion="requisicionSeleccionada"></detalle-de-candidatos-requisicion>
      </a-collapse-panel>
    </a-collapse>

    <a-modal title="Realizar Requisicion"
             :visible="registrarModal.visible"
             @ok="confirmarModalRegistrar"
             :confirmLoading="registrarModal.loading"
             @cancel="cancelModalRegistrar"
             width="90%"
             style="top: 20px;">
      <a-form :form="registrarModal.form">
        <a-row :gutter="[16,16]">
          <a-col :xs="24" :sm="12">
            <g-dropdown :label="$t('Tipo de Solicitud')"
                        :formItemConfig="registrarModal.fiOptions"
                        endpoint="hierarchy_lookup"
                        :decorator="['req_type_id', { rules: [{ required: true, message: 'Valor requerido' }]}]"
                        :params="{h_lookup_type: 'TIPO_REQUISICION'}"
                        ref="tipoReq"
                        :selectedObj.sync="registrarModal.tipoSolicitudSeleccionado">
            </g-dropdown>
          </a-col>
          <a-col :xs="24" :sm="12">
            <g-dropdown :label="$t('Motivo de Solicitud')"
                        :formItemConfig="registrarModal.fiOptions"
                        endpoint="hierarchy_lookup"
                        :decorator="['req_mot_id', { rules: [{ required: true, message: 'Valor requerido' }]}]"
                        :params="reqMotParams"
                        ref="req_mot_id"
                        :selectedObj.sync="registrarModal.motivoSolicitudSeleccionado">
            </g-dropdown>
          </a-col>
          <a-col :xs="24" :sm="12" v-if="mostrarOcupanteAnerior">
            <g-lookup
              :label="$t('Ocupante Anterior')"
              :formItemConfig="ocupanteAnteriorItemConfig"
              endpoint="empleados"
              :params="{estado_activo: true}"
              :decorator="['id_emp_bef']"
              :selectedObj.sync="registrarModal.ocupanteAntSeleccionado">
            </g-lookup>
          </a-col>
          <a-col :xs="24" :sm="12" v-if="mostrarOcupanteAnerior">
            <a-form-item :label="$t('Cargo Oc. Aterior')" v-bind="registrarModal.fiOptions">
              <a-input readOnly :value="registrarModal.ocupanteAntSeleccionado.cargo"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xs="24" :sm="12">
            <g-dropdown :label="$t('Compañía')"
                        :formItemConfig="registrarModal.fiOptions"
                        endpoint="company"
                        ref="company"
                        :selectedObj.sync="registrarModal.companySeleccionada"
                        :decorator="['id_company', { rules: [{ required: true, message: 'Valor requerido' }]}]">
            </g-dropdown>
          </a-col>
          <a-col :xs="24" :sm="12">
            <g-dropdown :label="$t('Oficina')"
                        :formItemConfig="registrarModal.fiOptions"
                        endpoint="cc_offices"
                        :params="officeParams"
                        :selectedObj.sync="registrarModal.oficinaSeleccionada"
                        :decorator="['office_id', { rules: [{ required: requeridos.oficina, message: 'Valor requerido' }]}]">
            </g-dropdown>
          </a-col>
          <a-col :xs="24" :sm="12">
            <g-dropdown :label="$t('PERSONALIZACION_CENTRO_COSTO_CENTRO_DE_COSTOS')"
                        :formItemConfig="registrarModal.fiOptions"
                        endpoint="cc_offices"
                        :params="ccParams"
                        :selectedObj.sync="registrarModal.centroCostoSeleccionado"
                        :cache="false"
                        :decorator="['cc_id', { rules: [{ required: requeridos.oficina, message: 'Valor requerido' }]}]">
            </g-dropdown>
          </a-col>
          <a-col :xs="24" :sm="12">
            <g-dropdown :label="$t('Cargo')"
                        :formItemConfig="registrarModal.fiOptions"
                        endpoint="cc_jobs"
                        :params="jobParams"
                        :decorator="['position_id', { rules: [{ required: true, message: 'Valor requerido' }]}]">
            </g-dropdown>
          </a-col>
          <a-col :xs="24" :sm="12">
            <a-form-item v-bind="registrarModal.fiOptions" :label="$t('Cantidad de Vacantes')">
              <a-input-number style="width: 100%;"
                              v-decorator="['vacant', { initialValue: 1, rules: [
                              { required: true, message: 'Valor requerido' },
                               { type: 'integer', min: 1, message: 'El valor debe ser mayor a cero' }
                              ]}]">
              </a-input-number>
            </a-form-item>
          </a-col>
          <a-col :xs="24" :sm="12">
            <a-form-item v-bind="registrarModal.fiOptions" :label="$t('Observaciones')">
              <a-textarea
                autoSize
                v-decorator="['req_obs2', { trigger: 'change', rules: [{ required: true, message: 'Valor requerido' }]}]">
              </a-textarea>
            </a-form-item>
          </a-col>
        </a-row>
        <a-alert
          message="Información del centro de costo"
          v-if="infoCc"
          type="info"
          show-icon>
          <div slot="description" v-html="infoCc"></div>
        </a-alert>
        <a-alert type="error" v-if="registrarModal.error">
          <div slot="message" v-html="registrarModal.mensajeError"></div>
        </a-alert>
      </a-form>
    </a-modal>


    <a-modal :title="confirmarModal.accion + 'Requisicion'"
             :visible="confirmarModal.visible"
             @ok="confirmEstado"
             :confirmLoading="confirmarModal.loading"
             @cancel="cancelConfirmEstado"
             style="top: 20px;">
      <span>¿Está seguro que desea {{confirmarModal.accion}} la requisición?</span>
      <a-alert type="error" :message="confirmarModal.mensajeError" v-if="confirmarModal.error"/>
    </a-modal>

  </div>
</template>
<script>
  import JsUtils from '@/util/JsUtils'
  import HttpUtil from '@/util/HttpUtil'
  import UserUtil from 'CustomModules/GlobalBPOCore/Util/UserUtil'

  export default {
    data () {
      return {
        activeKey: 1,
        requisicionSeleccionada: {},
        requisiciones: {
          confirmVisible: false,
          confirmLoading: false,
          arpobarRechazar: {},
          confirmMensaje: '',
          loadingBtns: {},
          endpoint: 'gestion_humana/requisiciones',
          tableSetup: {
            columns: [
              {title: 'Req.', dataIndex: 'req_id', sorter: true, width: 90},
              {
                title: 'Estado',
                dataIndex: 'estado',
                sorter: true,
                width: 130,
                scopedSlots: {
                  filterDropdown: 'filterDropdown',
                  filterIcon: 'filterIcon',
                  customRender: 'estadoRenderer'
                }
              },
              {title: 'Motivo', dataIndex: 'motivo', sorter: true},
              {title: 'Cargo Solicitado', dataIndex: 'cargo', sorter: true},
              {title: 'Prospecto', dataIndex: 'prospecto', sorter: true},
              {title: 'Compañia', dataIndex: 'company_desc', sorter: true},
              {title: 'Solicitado Por', dataIndex: 'solicitado_por', sorter: true},
              {title: 'Oficina', dataIndex: 'oficina', sorter: true},
              {title: 'Observaciones', dataIndex: 'req_obs2', sorter: true}
            ],
            actions: {
              title: 'Acciones',
              key: 'acciones',
              width: 90,
              fixed: 'right',
              scopedSlots: {customRender: 'hooverableAction'},
              actions: [
                {
                  name: 'detalles',
                  text: 'Detalles',
                  icon: 'search',
                  props: {size: 'small', type: 'link', icon: 'search', style: 'color:green;'}
                },

                {
                  name: 'aprobar',
                  text: 'Aprobar',
                  icon: 'check',
                  props: {size: 'small', type: 'link', icon: 'check', style: 'color:green;'},
                  fnVisible: (record) => {
                    return this.canApprove(record)
                  }
                },
                {
                  name: 'rechazar',
                  text: 'Rechazar',
                  icon: 'check',
                  props: {size: 'small', type: 'link', icon: 'close', style: 'color:red;'},
                  fnVisible: (record) => {
                    return this.canReject(record)
                  }
                },
                {
                  name: 'finalizar',
                  text: 'Finalizar',
                  icon: 'check',
                  props: {size: 'small', type: 'link', icon: 'check', style: 'color:green;'},
                  fnVisible: (record) => {
                    return record.estado === this.status.REQUISICIONES_ETAPA_ABIERTA && UserUtil.isInRol('RHandReq')
                  }
                },
                {
                  name: 'cerrar',
                  text: 'Cerrar',
                  icon: 'check',
                  props: {size: 'small', type: 'link', icon: 'unlock', style: 'color:blue;'},
                  fnVisible: (record) => {
                    return (record.estado === this.status.REQUISICIONES_ETAPA_FINALIZADA) && UserUtil.isInRol('RHandReq')
                  }
                },
                {
                  name: 'cerrado',
                  text: 'Cerrado',
                  icon: 'check',
                  props: {size: 'small', type: 'link', icon: 'lock', style: 'color:green;'},
                  fnVisible: (record) => {
                    return record.estado === this.status.REQUISICIONES_ETAPA_CERRADA
                  }
                }
              ]
            },
            tableConfig: {
              rowKey: 'req_id',
              pagination: {
                pageSize: 10,
                current: 1,
                showSizeChanger: true,
                pageSizeOptions: ['5', '10', '20', '30', '40'],
                showTotal: (total, range) => `${range[0]}-${range[1]} de ${total} registros`
              }
            },
            requestData: {},
            customSlots: ['estadoRenderer', 'customAction', 'expandedRowRender']
          },
          valoresExpandidos: [
            {label: 'Unidad de Negocio', column: 'unidad'},
            {label: 'Linea', column: 'linea'},
            {label: 'Operación', column: 'operacion'},
            {label: 'Empleado Autoriza', column: 'id_empleado_auto'},
            {label: 'Nombre Autoriza', column: 'nombre_auto'},
            {label: 'Cargo Autoriza', column: 'cargo_auto'},
            {label: 'Estado Proceso RH', column: 'estado_prc_rh'},
            {label: 'Cubrimiento Vacante', column: 'cubrimiento_vacante'},
            {label: 'Elementos Requeridos', column: 'elementos_requeridos'}
          ],
          actions: [
            {
              name: 'registrar',
              text: 'Registrar',
              icon: 'plus',
              permisos: [],
              props: {},
              fnVisible: () => {
                return this.$userIsInrol('JefeReq')
              }
            }
          ]
        },
        registrarModal: {
          loadig: false,
          visible: false,
          error: false,
          mensajeError: '',
          motivoSolicitudSeleccionado: {},
          tipoSolicitudSeleccionado: {},
          ocupanteAntSeleccionado: {},
          companySeleccionada: {},
          oficinaSeleccionada: {},
          centroCostoSeleccionado: {},
          fiOptions: {
            'label-col': {span: 8},
            'wrapper-col': {span: 16},
            'has-feedback': true
          },
          tipo_cargo_params: {h_lookup_type: 'CLASIFICACION_CARGO'},
          tiempo_req_params: {h_lookup_type: 'TIEMPO_REQ', use_code: true},
          tipo_op_params: {h_lookup_domain: 'OPER'},
          agency_params: {h_lookup_type: 'REQ_AGENCIA'},
          form: null
        },
        confirmarModal: {
          accion: '',
          visible: false,
          loading: false,
          mensajeError: '',
          error: false
        },
        requeridos: {
          agencia: false,
          oficina: false
        },
        defaultReqData: {},
        ocupanteAnteriorItemConfig: {},
        ocupanteAnteriorItemConfigLoading: false,
        ocupanteAnteriorLastRequest: null,
        status: {
          REQUISICIONES_ETAPA_INICIADA: '00',
          REQUISICIONES_ETAPA_ABIERTA: '00',
          REQUISICIONES_ETAPA_FINALIZADA: '00',
          REQUISICIONES_ETAPA_CERRADA: '00',
          REQUISICIONES_ETAPA_RECHAZADA: '00'
        }
      }
    },
    beforeMount () {
      this.registrarModal.form = this.$form.createForm(this, {
        name: 'registrarReq',
        onValuesChange: (_, changedFields) => {
          this.registrarModalValuesChanged(changedFields)
        }
      })

      this.requeridos.agencia = this.$getConfigValue('REQUISICIONES_AGENCIA_REQUERIDO', false) === 'SI'
      this.requeridos.oficina = this.$getConfigValue('REQUISICIONES_OFICINA_REQUERIDO', false) === 'SI'
    },
    mounted () {
      this.httpClient = new HttpUtil('gestion_humana/requisiciones')

      let tipoSol = this.$getConfigValue('REQUISICIONES_DEFAULT_TIPO_SOLICITUD', null)
      let motivoSol = this.$getConfigValue('REQUISICIONES_DEFAULT_MOTIVO_SOLICITUD', null)
      let tipoOp = this.$getConfigValue('REQUISICIONES_DEFAULT_TIPO_OPERACION', null)
      let company = this.$getConfigValue('REQUISICIONES_DEFAULT_COMPAÑIA', null)
      let tipoCargo = this.$getConfigValue('REQUISICIONES_DEFAULT_TIPO_CARGO', null)

      this.defaultReqData.req_type_id = JsUtils.isEmpty(tipoSol) ? null : tipoSol
      this.defaultReqData.id_h_value1 = JsUtils.isEmpty(tipoOp) ? null : tipoOp
      this.defaultReqData.id_company = JsUtils.isEmpty(company) ? null : company
      this.defaultReqData.id_h_type_job = JsUtils.isEmpty(tipoCargo) ? null : tipoCargo
      this.defaultReqData.req_mot_id = JsUtils.isEmpty(motivoSol) ? null : motivoSol

      this.registrarModal.form.getFieldDecorator('req_type_id')
      this.registrarModal.form.getFieldDecorator('id_h_value1')
      this.registrarModal.form.getFieldDecorator('id_company')
      this.registrarModal.form.getFieldDecorator('id_h_type_job')
      this.registrarModal.form.getFieldDecorator('req_mot_id')

      this.ocupanteAnteriorItemConfig = {
        ...this.registrarModal.fiOptions,
        help: 'Seleccione un ocupante anterior para visualizar detalles.'
      }

      this.status.REQUISICIONES_ETAPA_INICIADA = this.$getConfigValue('REQUISICIONES_ETAPA_INICIADA', '00')
      this.status.REQUISICIONES_ETAPA_ABIERTA = this.$getConfigValue('REQUISICIONES_ETAPA_ABIERTA', '00')
      this.status.REQUISICIONES_ETAPA_FINALIZADA = this.$getConfigValue('REQUISICIONES_ETAPA_FINALIZADA', '00')
      this.status.REQUISICIONES_ETAPA_CERRADA = this.$getConfigValue('REQUISICIONES_ETAPA_CERRADA', '00')
      this.status.REQUISICIONES_ETAPA_RECHAZADA = this.$getConfigValue('REQUISICIONES_ETAPA_RECHAZADA', '00')
    },
    methods: {
      masterAction (action) {
        switch (action.action) {
          case 'registrar':
            this.mostrarModalRegistrar()
            break
          case 'detalles':
            this.activeKey = 2
            this.requisicionSeleccionada = action.record
            break
          case 'aprobar':
            this.confirmarModal.req_id = action.record.req_id
            this.confirmarModal.accion = 'aprobar'
            this.confirmarModal.visible = true
            this.confirmarModal.error = false
            this.confirmarModal.loading = false
            break
          case 'rechazar':
            this.confirmarModal.req_id = action.record.req_id
            this.confirmarModal.accion = 'rechazar'
            this.confirmarModal.visible = true
            this.confirmarModal.error = false
            this.confirmarModal.loading = false
            break
          case 'finalizar':
            this.confirmarModal.req_id = action.record.req_id
            this.confirmarModal.accion = 'finalizar'
            this.confirmarModal.visible = true
            this.confirmarModal.error = false
            this.confirmarModal.loading = false
            break
          case 'cerrar':
            this.confirmarModal.req_id = action.record.req_id
            this.confirmarModal.accion = 'cerrar'
            this.confirmarModal.visible = true
            this.confirmarModal.error = false
            this.confirmarModal.loading = false
            break
        }
      },
      registrarModalValuesChanged (changedFields) {
        if (!JsUtils.isEmpty(changedFields.req_mot_id)) {
          this.registrarModal.form.setFieldsValue({
            id_emp_bef: null
          })
          this.registrarModal.ocupanteAntSeleccionado = {}
        }
      },
      confirmarModalRegistrar (e) {
        e.preventDefault()
        this.registrarModal.form.validateFields((err, values) => {
          if (!err) {
            this.registrarModal.loading = true
            this.httpClient.getInstance().post('gestion_humana/requisiciones', values).then((response) => {
              this.registrarModal.loading = false
              if (JsUtils.isEmpty(response.data)) {
                this.registrarModal.error = true
                this.registrarModal.mensajeError = 'Error desconocido, por favor contactar al administrador.'
              } else {
                if (parseInt(response.data.resultado) === 2) {
                  this.refreshTable()
                  this.registrarModal.form.resetFields()
                  this.registrarModal.visible = false
                } else {
                  this.registrarModal.error = true
                  this.registrarModal.mensajeError = response.data.mensaje
                }
              }
            }).catch((error) => {
              this.registrarModal.error = true
              this.registrarModal.loading = false
              this.registrarModal.mensajeError = this.$getErrorMessage(error, 'No fue posible registrar la requisición')
            }).then(() => {
              this.registrarModal.loading = false
            })
          }
        })
      },
      cancelModalRegistrar () {
        if (this.registrarModal.loading) return
        this.registrarModal.visible = false
        this.registrarModal.loading = false
        this.registrarModal.error = false
        this.registrarModal.mensajeErrorError = ''
      },
      mostrarModalRegistrar () {
        this.registrarModal.visible = true
        this.registrarModal.loading = false
        this.registrarModal.error = false
        this.registrarModal.mensajeErrorError = ''

        this.$nextTick(() => {
          this.registrarModal.form.setFieldsValue(this.defaultReqData)
          this.$refs.company && this.$refs.company.handleChange(JsUtils.isEmpty(this.defaultReqData.id_company) ? null : this.defaultReqData.id_company)
          this.$refs.tipoReq && this.$refs.tipoReq.handleChange(JsUtils.isEmpty(this.defaultReqData.req_type_id) ? null : this.defaultReqData.req_type_id)
          this.$refs.req_mot_id && this.$refs.req_mot_id.handleChange(JsUtils.isEmpty(this.defaultReqData.req_mot_id) ? null : this.defaultReqData.req_mot_id)
        })
      },
      refreshTable () {
        this.$refs.masterComponent.$refs.datatable.loadData()
      },
      cancelConfirmEstado () {
        if (this.confirmarModal.loading) return

        this.confirmarModal.visible = false
        this.confirmarModal.error = false
        this.confirmarModal.accion = ''
      },
      confirmEstado () {
        if (this.confirmarModal.loading) return
        this.confirmarModal.loading = true
        this.httpClient.getInstance().post('gestion_humana/requisiciones/' + this.confirmarModal.accion, {
          req_id: this.confirmarModal.req_id
        }).then((response) => {
          if (JsUtils.isEmpty(response.data)) {
            this.confirmarModal.error = true
            this.confirmarModal.mensajeError = 'Error desconocido, por favor contactar al administrador.'
          } else {
            if (parseInt(response.data.resultado) === 2) {
              this.refreshTable()
              this.confirmarModal.error = false
              this.confirmarModal.loading = false
              this.confirmarModal.visible = false
            } else {
              this.confirmarModal.error = true
              this.confirmarModal.mensajeError = response.data.mensaje
              this.confirmarModal.loading = false
            }
          }
        }).catch((error) => {
          this.confirmarModal.error = true
          this.confirmarModal.mensajeError = error && error.response && error.response.data && error.response.data.message
          this.confirmarModal.loading = false
        })
      },
      setOcupanteAnteriorHelp (text) {
        this.ocupanteAnteriorItemConfig = {...this.ocupanteAnteriorItemConfig, help: text}
      },
      canApprove (requisicion) {
        let i = parseInt(requisicion.status)
        return this.$userIsInrol(`REQ_WF_${i}`)
      },
      canReject (requisicion) {
        let hrReqPuedeRechazar = parseInt(requisicion.status) <= parseInt(this.status.REQUISICIONES_ETAPA_INICIADA)

        return this.canApprove(requisicion) || (this.$userIsInrol('HRReq') && hrReqPuedeRechazar)
      }
    },
    watch: {
      'registrarModal.ocupanteAntSeleccionado': function () {
        /* carga la descriptión */
        if (JsUtils.isEmpty(this.registrarModal.ocupanteAntSeleccionado)) {
          this.setOcupanteAnteriorHelp('')
        } else {
          this.setOcupanteAnteriorHelp('Cargando...')
          try {
            this.ocupanteAnteriorLastRequest && this.ocupanteAnteriorLastRequest.cancel()
          } catch (e) {
            //
          }

          this.ocupanteAnteriorLastRequest = this.httpClient.getInstance().get(`gestion_humana/requisiciones/detalle_oc_anterior/${this.registrarModal.ocupanteAntSeleccionado.value}`)
            .then(response => {
              this.setOcupanteAnteriorHelp(response.data)
            })
            .catch(() => {
              this.setOcupanteAnteriorHelp('Error consultando información.')
            })
        }
      },
      'registrarModal.companySeleccionada': function () {
        this.registrarModal.form.setFieldsValue({
          office_id: null,
          cc_id: null,
          position_id: null
        })
      },
      'registrarModal.oficinaSeleccionada': function () {
        this.registrarModal.form.setFieldsValue({
          cc_id: null,
          position_id: null
        })
      },
      'registrarModal.centroCostoSeleccionado': function () {
        this.registrarModal.form.setFieldsValue({
          position_id: null
        })
      }
    },
    computed: {
      mostrarOcupanteAnerior () {
        return this.registrarModal.motivoSolicitudSeleccionado.equivalency === 'S'
      },
      officeParams () {
        let company = -1
        if (!JsUtils.isEmpty(this.registrarModal.companySeleccionada)) {
          company = this.registrarModal.companySeleccionada.value
        }

        return {use_office: true, id_company: company}
      },
      ccParams () {
        let office = -1
        if (!JsUtils.isEmpty(this.registrarModal.oficinaSeleccionada)) {
          office = this.registrarModal.oficinaSeleccionada.value
        }

        return {use_cc: true, office_id: office}
      },
      jobParams () {
        let cc = -1
        if (!JsUtils.isEmpty(this.registrarModal.centroCostoSeleccionado)) {
          cc = this.registrarModal.centroCostoSeleccionado.value
        }

        return {id_cc: cc}
      },
      infoCc () {
        if (!JsUtils.isEmpty(this.registrarModal.centroCostoSeleccionado)) {
          let unitName = this.registrarModal.centroCostoSeleccionado.unit_name
          let segmentName = this.registrarModal.centroCostoSeleccionado.segment_name
          let prjName = this.registrarModal.centroCostoSeleccionado.prj_name
          let jefeName = this.registrarModal.centroCostoSeleccionado.emp_desc

          return `<strong>${this.$t('PERSONALIZACION_CENTRO_COSTO_UNIDAD')}:</strong> ${unitName} <br/>
                  <strong>${this.$t('PERSONALIZACION_CENTRO_COSTO_SEGMENTO')}:</strong> ${segmentName} <br/>
                  <strong>${this.$t('PERSONALIZACION_CENTRO_COSTO_PROYECTO')}:</strong> ${prjName} <br/>
                  <strong>${this.$t('Jefe')}:</strong> ${jefeName}`
        }
        return ''
      },
      reqMotParams () {
        return {
          h_lookup_type: 'MOTIVO_REQUISICION',
          id_h_lookup_father: (this.registrarModal.tipoSolicitudSeleccionado.value || -1)
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/GestionHumana/Requisiciones/Requisiciones.vue